import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type UserRole = 'admin' | 'reception' | 'atelier' | 'mecanicien';

export type AppUser = {
  id: string;
  email: string;
  prenom: string;
  nom: string;
  role: UserRole;
  mecanicienId: string | null;
  actif: boolean;
  createdAt: string;
};

export type CreateUserInput = {
  email: string;
  password: string;
  prenom: string;
  nom: string;
  role: UserRole;
  mecanicienId?: string;
};

export type UpdateUserInput = Partial<{
  prenom: string;
  nom: string;
  role: UserRole;
  mecanicienId: string | null;
  actif: boolean;
  password: string;
}>;

export function useUsers() {
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: () => api.get<{ users: AppUser[] }>('/admin/users'),
    select: (d) => d.users,
  });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateUserInput) =>
      api.post<{ user: AppUser }>('/admin/users', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'users'] }),
  });
}

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateUserInput }) =>
      api.patch<{ user: AppUser }>(`/admin/users/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'users'] }),
  });
}
